import { Maybe } from 'graphql/jsutils/Maybe';

import {
  MediumEnum,
  PaidService,
  PaymentCreateYigimTemplateGroupEnum,
  PaymentMethodEnum
} from '@/__generated_graphql__/graphql';
import { MappedServiceType } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';

export type ModalControls = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export type UsePaymentModalsManagerResult = {
  isAnotherModal: boolean;
  closeAll: () => void;
  success: ModalControls;
  successTopUp: ModalControls;
  error: ModalControls;
  errorTopUp: ModalControls;
  failed: ModalControls;
  emptyBalance: ModalControls;
};

export type HandlePaymentArgs = {
  paidServiceId: string | null;
  targetId: Maybe<string>;
  paymentMethodId: PaymentMethodEnum;
  servicePeriodId?: number;
  platform?: MediumEnum;
  isAddBalance?: boolean;
  amount?: number | null;
  yigimTemplateGroup?: PaymentCreateYigimTemplateGroupEnum;
};

export const MODAL_TYPES = {
  SUCCESS: 'success',
  SUCCESS_TOP_UP: 'success_top_up_balance',
  ERROR: 'error',
  ERROR_TOP_UP: 'error_top_up',
  FAILED: 'failed',
  EMPTY_BALANCE: 'empty_balance'
};

export type MODAL_TYPES = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];

export type PaidServiceOption = {
  id: string;
  name: string;
  price: number;
  description: string | null;
  discount: string | null;
};

export type PaidServicePaymentMethod = {
  balance: number | null;
  id: string;
  name: string;
};

export type UseServicePeriodOptionsParams = {
  paidServices: PaidService[];
  serviceType: MappedServiceType;
  activePeriodId: number | null;
  setActivePeriodId: (id: number) => void;
  setSelectedServiceId: (id: string) => void;
};
